class PostTemplate {
	getElement (post) {
		const div = document.createElement('div')
		div.innerHTML = this.getHtml(post)
		return div.firstElementChild
	}
	getHtml (post) {
		// console.log(post) // Odkomentuj jeżeli chcesz sprawdzić dostępnę wartości na widoku

		const image = post.imageLink ? /* html */ `
			<picture>
				<img src="${post.imageLink}" alt="${post.title}" class="blog-img">
			</picture>
		` : ''

		return /* html */`
			<div class="col-12 col-lg-6">
				<div class="blog-item">
						<a class="blog-img-wrapper" href="${post.link}" title="${post.title}">
							${image}
						</a>
					<div class="blog-content-wrapper">
						<div class="blog-date">
							<p>${post.published.split(' ')[0]}</p>
						</div>

						<a href="${post.link}">
							<h3 class="blog-title">${post.title}</h3>
						</a>

						<p class="blog-readmore">${post.description.length < 200 ? post.description : post.description.slice(0, 200) + '...'}</p>
						<div class="btn-wrapper">
							<a class="btn btn--light" href="${post.link}">
								<span>Przejdź do wpisu</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		`
	}
}

const postTemplate = new PostTemplate()
export { PostTemplate, postTemplate }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_posts_loader/template/PostTemplate.js